import axios from 'axios'

import { IEnrollmentHistory } from '@/features/curriculum/types/permission'
import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

import { IProgress, IProgressResource, IProgressResponse } from '../types'

export const requestProgressNow = async (courseId: string) => {
  const resp = await axios.get<IProgressResource>(
    `${window.apiEndpoint}/my/progress/v1/${courseId}/now`,
  )
  return convertCaseList(resp.data, ConvertType.CAMEL)
}

export const requestProgressList = async (courseId: string) => {
  const resp = await axios.get<IProgressResponse>(
    `${window.apiEndpoint}/my/progress/v1/${courseId}`,
  )
  return convertCaseList(resp.data, ConvertType.CAMEL) as IProgress
}

export const requestCourseSinglePermission = async (courseId: string) => {
  const resp = await axios.get<IListDataResp<IEnrollmentHistory>>(
    `${window.apiEndpoint}/my/permission/v1/enrollments?course_id=${courseId}&page=1&per_page=1`,
  )

  return convertCaseList(resp.data, ConvertType.CAMEL)
}
